export const SELF_SERVICE_ONBOARDING_FLAG = 'self-service-onboarding';
/** Node-agent calls judge events, signals and form answers on Jev first. */
export const JEV_FLAG = 'jev';
//# sourceMappingURL=feature-flags.js.map